module.exports = __webpack_public_path__ + "static/intelllex-reversed-logo.9b8ea1e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intelllex-reversed-logo.png
// module id = 47
// module chunks = 35783957827783 226383347778272